import React from 'react'
import Animate from 'react-move/Animate'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import classNames from 'classnames'

// See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_animated_properties for
// list of properties which can be animated via transition

const styleSheet = {
    animationContainer: {
        position: 'absolute',
        opacity: ({ opacity }) => opacity,
        width: ({ width }) => width || '100%',
        height: ({ height }) => height || '100%',
        top: ({ top }) => top || 0,
        left: ({ left }) => left,
        right: ({ right }) => right,
        bottom: ({ bottom }) => bottom,
        zIndex: ({ zIndex }) => zIndex,
    },
}

const style = injectSheet(styleSheet)

const AnimatedDiv = compose(
    style,
    pure
)(({ children, classes, className, style, ...rest }) => (
    <div style={style} className={classNames(classes.animationContainer, className)} {...rest}>
        {children}
    </div>
))

const withAnimatedProps = ({ show, start, enter, update, leave, ...rest }, props) => {
    const handleFunction = (f, props) => (typeof f === 'function' ? f(props) : f)

    return {
        show: handleFunction(show, props),
        start: handleFunction(start, props),
        enter: handleFunction(enter, props),
        update: handleFunction(update, props),
        leave: handleFunction(leave, props),
        ...rest,
    }
}

const withClassNameProps = (className, props) => (typeof className === 'function' ? className(props) : className)

const WithAnimation = ({ className, style, ...animateProps }) => WrappedComponent => props => (
    <Animate {...withAnimatedProps(animateProps, props)}>
        {animationState => {
            return (
                <AnimatedDiv className={withClassNameProps(className, props)} style={style} {...animationState}>
                    <WrappedComponent {...props} />
                </AnimatedDiv>
            )
        }}
    </Animate>
)

export default WithAnimation
